import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IColumnDef, ICommonDropdownResponse } from './common-table.model';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { JwtService } from '../../auth/jwtservice';
import { CallingService } from '../../services/common/calling.service';
import { ToasterService } from '../../services/common/toaster.service';
import { CommonService } from '../../services/common/common.service';
import { TokenPropertyUrl } from '../../../appconfig';
import { SalesService } from '../../main-layout/sales/sales.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrl: './common-table.component.scss'
})

export class CommonTableComponent implements OnInit, OnChanges {

  @Input({ required: true }) columnDefs: IColumnDef[] = [];
  @Input({ required: true }) data: any[] = [];
  @Output() commonDropdownChange = new EventEmitter<ICommonDropdownResponse>();
  @Output() changeModelStatus = new EventEmitter<any>();
  @Output() selectedRowsChange: EventEmitter<any[]> = new EventEmitter();
  @Output() hyperlinkClicked = new EventEmitter<any>();
  @Output() rowAction = new EventEmitter<{ action: any; row: any }>();
  @Input() showSearchBar: boolean = true;
  @Input() enableRowStyles: boolean = false;
  @Input() rowStyles!: any[];
  @ViewChild('dt') dt: Table | undefined;
  options = ["Edit", "Delete"];
  allSelected: boolean = false; // To track the state of the select all checkbox
  filteredData!: any[];
  searchTerm: string = '';
  selectedAction: any;
  fields: string[] = [];
  dataCopy: any[] = [];
  selectedItem: any;
  selectedRows: any[] = [];
  viewedContactNumber: any;
  viewContactModal: boolean = false;
  currentUserContactNumber: any;
  roleListData: any;
  showContactColumn: boolean = false;
  showCallIcon: boolean = false;
  constructor(private route: Router, private jwtService: JwtService,
    private callingService: CallingService, private toasterService: ToasterService,
    public commonService: CommonService, private salesService: SalesService) {
  }

  async ngOnInit() {
    this.roleListData = await firstValueFrom(this.jwtService.currentUserRole$());
    this.filteredData = this.dataCopy;
    this.fields = [];
    if (this.columnDefs && Array.isArray(this.columnDefs)) {
      this.columnDefs.forEach((value, index) => {
        this.fields.push(value.field);
      })
    }
    //  this.getRoleList();
    if (this.roleListData.includes('View_Client_Contacts')) {
      this.showContactColumn = true;
    } else {
      this.showContactColumn = false;
    }

    if (this.roleListData.includes('Can_Call_Client')) {
      this.showCallIcon = true;
    } else {
      this.showCallIcon = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataCopy = [];
    if (changes["data"] && changes["data"].currentValue?.length > 0) {

      const updatedData = changes["data"]?.currentValue?.map((row: any, i: any) => {
        this.fields.forEach(element => {
          if (row[element] && typeof row[element] != 'object' && !Array.isArray(row[element])) {
            row[`${element}_Copy`] = row[element].toString().replace(/[^a-zA-Z0-9]/gi, "");

            this.columnDefs.push({
              columnType: "text",
              field: `${element}_Copy`,
              header: `${element}_Copy`
            });
          }
        });
        return row;
      })
      this.dataCopy = updatedData;
    }
  }

  getRowStyle(rowId?: number): any {
    if (!this.enableRowStyles) return {};
    const rowStyle = this.rowStyles.find(style => style.id === rowId);
    return rowStyle ? rowStyle.style : {};
  }

  /**
   *
   * @param $event filter the table data globally
   * @param filterType which type of filter need to be used
   */
  filterData($event: any, filterType: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, filterType);

  }

  /**
   * action dropdown click
   * @param event current event to be triggered
   * @param selectedRow from which row we are triggering the action's option
   * @param options which option of dropdown we have triggered
   */
  onDropdownClick(event: any, selectedRow: any, options: any[]) {
    // If the new value is the same as the previous one, force the update
    if (this.selectedAction === event.value) {
      // Trigger the change manually
      this.commonDropdownChange.emit(<any>{
        route: event.value,
        currentRow: selectedRow
      });
      this.selectedAction = '';  // Reset if needed
    } else {
      this.selectedAction = event.value;
    }

    // Trigger the change event on the parent
    this.commonDropdownChange.emit(<any>{
      route: event.value,
      currentRow: selectedRow
    });
    this.selectedAction = '';
  }

  //if clicked on image which is in cell
  onImageClick(event: any, selectedRow: any) {
    this.changeModelStatus.emit({
      "currentRow": selectedRow,
    });
  }

  //for select all checkbox
  toggleSelectAll(event: any) {
    const checked = event?.checked;
    this.allSelected = checked;
    this.dataCopy.forEach(item => item['selection'] = checked);
    this.selectedRowsChange.emit(this.dataCopy);
  }

  updateSelectAll() {
    const allChecked = this.dataCopy.every(item => item['selection']);
    this.allSelected = allChecked;
  }

  //for checkbox change
  onCheckboxChange(event: any, currentRow: any): void {
    currentRow.checked = event?.checked;
    if (currentRow?.checked === true) {
      this.selectedRows.push(currentRow);
      this.selectedRowsChange.emit(this.selectedRows);
    }
    // Additional logic
  }

  //for single selection of checkbox
  onRadioChange(event: any, currentRow: any): void {
    currentRow.selection = true;
    this.selectedRows = currentRow;
    this.selectedRowsChange.emit(this.selectedRows);
    // Additional logic
  }
  // Method to get options for dropdown
  getOptions(columnDef: any): SelectItem[] {
    return columnDef.options || [];
  }

  setTextLegth(data: string, textLength?: any) {
    if (textLength)
      return (data.slice(0, textLength) + '...')
    else
      return data
  }

  // Method to handle icon click actions
  onIconClick(action: any, row: any) {
    this.rowAction.emit({ action, row })
  }

  /**
   * This method filters the dropdown options based on the selected value.
   * It removes 'Allotment' in payment screen action menu if current payment row is for 'Booking' and vice versa.
   * Additionally, it removes 'Cancel' if 'Booking' is selected and the current record has isRequestedForCancellation as true.
   * @param options option list of dropdown
   * @param selectedValue current selected value of dropdown
   * @param currentRecord current row data
   * @returns returns the filtered options
   */
  filterOptions(options: any, selectedValue: any, currentRecord: any) {
    const filterData = options.filter((option: any) => {
      if (selectedValue === 'Booking' && option.value === 'allotment') {
        return false; // Remove allotment if booking is selected
      }
      if (selectedValue === 'Allotment' && option.value === 'booking') {
        return false; // Remove booking if allotment is selected
      }
      if (selectedValue === 'Booking' && option.value === 'cancel' && currentRecord?.isRequestedForCancellation == true) {
        return false; // Remove allotment if booking is selected
      }
      return true; // Keep all other options
    });
    return filterData;
  }

  onClickEyeOfContactColumn(cellData: any) {
    this.viewContactModal = true
    this.viewedContactNumber = cellData;
    this.currentUserContactNumber = this.jwtService.getUserPropertyValueFromToken(TokenPropertyUrl.contactNumber).replace(/(\d{5})(\d{5})/, '$1-$2');
  }

  clickToCall(event: any) {
    event.preventDefault();
    const callContactData = {
      to: this.viewedContactNumber.replace(/-/g, '').toString(),
      from: this.currentUserContactNumber.replace(/-/g, '').toString()
    }
    this.callingService.postCallContacts(callContactData).subscribe({
      next: (response) => {
        this.toasterService.showSuccess('You will receive call shortly.')
      },
      error: (err) => {
        this.toasterService.showError('System is not able to connect, Kindly connect with administrator.')
      }
    })
  }

  handleHyperlinkClick(event: MouseEvent, col: IColumnDef, currentRow: any): void {
    // If route is defined, we let the routerLink do its job.
    // Still emit the event to the parent regardless.
    event.stopPropagation(); // Prevent row selection if needed
    if (col.onClick) {
      col.onClick(currentRow); // Component-specific action
    }
    this.hyperlinkClicked.emit(currentRow); // Emit to parent
  }
}

export { IColumnDef };

